/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type thirdparty_ProductCreateRequest = {
    active?: boolean;
    cost_price?: number;
    delivery_method: thirdparty_ProductCreateRequest.delivery_method;
    external_product_id: string;
    external_sku?: string;
    fulfillment_type: thirdparty_ProductCreateRequest.fulfillment_type;
    inventory_mode: thirdparty_ProductCreateRequest.inventory_mode;
    markup_percentage?: number;
    /**
     * ProductCategory — chỉ dùng khi supplier.supplier_type="reservation". Giai đoạn 1 chỉ chấp nhận
     * "court".
     */
    product_category?: thirdparty_ProductCreateRequest.product_category;
    product_name?: string;
    stock_quantity?: number;
    supplier_id: number;
};
export namespace thirdparty_ProductCreateRequest {
    export enum delivery_method {
        EMAIL = 'email',
        API_CALLBACK = 'api_callback',
        MANUAL = 'manual',
    }
    export enum fulfillment_type {
        INSTANT = 'instant',
        MANUAL = 'manual',
        SCHEDULED = 'scheduled',
    }
    export enum inventory_mode {
        UNLIMITED = 'unlimited',
        TRACKED = 'tracked',
        SYNCED = 'synced',
    }
    /**
     * ProductCategory — chỉ dùng khi supplier.supplier_type="reservation". Giai đoạn 1 chỉ chấp nhận
     * "court".
     */
    export enum product_category {
        COURT = 'court',
    }
}

